import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidatePolicies } from '@/modules/Policy/gql/policy.gql'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchPolicy extends Vue {
  candidatesPolicy: Policy[] = []

  get candidatesPolicyOptions () {
    return this.candidatesPolicy.map(item => {
      return {
        id: +item.id,
        name: item.policyName,
        status: item.status,
        policyNumber: item.policyNumber,
        effectiveDate: item.effectiveDate,
        expirationDate: item.expirationDate,
        account: item.account,
        recordType: item.recordType
      }
    })
  }

  async getCandidatePolicies (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidatePolicies,
        variables: {
          filter: {
            policyName: val
          },
          paging: {
            offset: 0,
            limit: 100
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesPolicy = result.data.getPolicies.policies
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
